<form [formGroup]="formGroup" autocomplete="off">
  @for (row of fieldIDs; track $index) {
    @let first = $first;
    @let last = $last;

    <div class="row g-3 mb-3">
      @for (id of row; track id) {
        <div [ngClass]="getColumnClass($first, $last, first, last)" class="col-12">
          <div class="form-floating">
            <input
              (input)="setContext(id)"
              (selectItem)="onSelectItem($event)"
              (keydown)="onKeydown($event)"
              [attr.type]="'text'"
              [pattern]="id.includes('zipCode') ? '[A-Z0-9\\- ]*' : null"
              [formControlName]="id"
              [id]="id"
              [inputFormatter]="isSearchableField(id) ? formatters[id] : null"
              [maxlength]="id.includes('zipCode') ? 10 : null"
              [ngClass]="{
                'is-valid': getIsValid(id),
                'is-invalid': getIsInvalid(id),
              }"
              [ngbTypeahead]="isSearchableField(id) ? searchFields[id] : null"
              [readonly]="id === 'location'"
              [resultFormatter]="isSearchableField(id) ? resultFormatter : null"
              [resultTemplate]="isSearchableField(id) ? resultPreview : null"
              [popperOptions]="typeaheadPosition"
              (focus)="setFocusAndClick($event, id)"
              (click)="setFocusAndClick($event, id)"
              [attr.data-test]="'form-address-input-' + id"
              class="form-control"
              popupClass="max-height-200"
            />
            @if (isLoading() === id) {
              <div class="form-floating-icon">
                <div class="loading-spinner"></div>
              </div>
            }
            <label [for]="id">
              {{ getLabelKey(id) | translate }}
              @if (id.toLowerCase().includes('door') && !isControlEnabled('door')) {
                {{ 'address-input.inputLabel.optional' | translate }}
              }
            </label>
          </div>
          @if (getIsInvalid(id)) {
            <div [attr.id]="'form-input-desc--' + id" class="row gx-1 font-size-12 text-danger mt-1">
              <div class="col-auto"><i class="fa fa-exclamation-circle" aria-hidden="true"></i></div>
              <div class="col">
                @if (id === 'zipCode') {
                  <span>{{ getZipCodeErrorLabelKey(id) | translate }}</span>
                } @else {
                  <span>{{ getErrorLabelKey(id) | translate }}</span>
                }
              </div>
            </div>
          }
        </div>
      }
    </div>
  }
</form>

@if (showError()) {
  <div class="mb-3">
    <mwe-inline-notification
      type="danger"
      titleKey="address-input.networkError.title"
      messageKey="address-input.networkError.message"
      ctaLabelKey="address-input.networkError.ctaLabel"
      (onCTAClick)="reloadPage()"
    />
  </div>
}

@if (!isLoading()?.length && hasNoResults() && ignoreAvailableZipCodes()) {
  <div class="mb-3">
    <mwe-inline-notification
      titleKey="address-input.noResult.title"
      ctaLabelKey="address-input.noResult.ctaLabel"
      (onCTAClick)="noResultsFound.emit(true)"
    />
  </div>
}

<ng-template #resultPreview let-result="result" let-term="term">
  <i class="fas fa-map-marker-alt mr-2"></i>
  <ngb-highlight [result]="resultFormatter(result)" [term]="term" />
</ng-template>
